export const renderStatus = {
	failure: 'FAILURE',
	revoked: 'REVOKED',
	success: 'SUCCESS',
	pending: 'PENDING',
	started: 'STARTED',
	retry: 'RETRY',
};
